import React from 'react';
import ReactDOM from 'react-dom';
import App from './ui/App';
import './index.css';

// @ts-ignore
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
